import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * This directive helps to narrow type of variables defined at ng-template level
 * https://angular.io/guide/structural-directives#typing-the-directives-context
 *
 * e.g.
 *
 * html
 * <ng-template #defaultTemplate [templateContext]="itemContext" let-branch>
 *   {{ branch.name }}
 *
 * ts
 * itemContext!: { $implicit: GitBranch };
 *
 * In the example above 'branch' template variable will be a type of 'GitBranch'
 * and trying to write smth like
 * {{ branch.unknownProp }}
 * will throw an error at compile time
 */
// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'ng-template[templateContext]', standalone: true })
export class TemplateContextGuardDirective<T> {
  constructor(private readonly contentTemplate: TemplateRef<T>) {}

  @Input() templateContext!: T;

  // tell Angular the context type for this directive, which then propagates down to the type of the template
  static ngTemplateContextGuard<T>(dir: TemplateContextGuardDirective<T>, ctx: unknown): ctx is T {
    return true;
  }
}
